import axios from "axios";

const API = "/api";
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

export async function carregarConfig() {
  const { data } = await axios.get(`${API}/campaigns/daily-offers/config`, auth());
  return data;
}

export async function salvarConfig(corpo) {
  const { data } = await axios.put(`${API}/campaigns/daily-offers/config`, corpo, auth());
  return data;
}

export async function carregarRelatorio({ inicio, fim }) {
  const { data } = await axios.get(`${API}/campaigns/daily-offers/report`, {
    ...auth(), params: { date_from: inicio, date_to: fim },
  });
  return data;
}
